import { createLazyFileRoute } from "@tanstack/react-router";

import { trpc } from "@blis/trpc/react";

import { ErrorPage } from "@/components/ErrorPage";
import { LoadingPage } from "@/components/LoadingPage";
import { Breadcrumb } from "@/components/ui/breadcrumbs";
import { Button } from "@/components/ui/button";
import { ProcessTemplateDetails } from "@/features/admin/components/processes/ProcessTemplateDetails";
import { Section } from "@/features/admin/components/Section";

export const Route = createLazyFileRoute("/_auth/admin/processes/$id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();

  const {
    data: template,
    isError,
    isPending,
    error,
  } = trpc.admin.process.getTemplate.useQuery(params);

  if (isPending) {
    return <LoadingPage />;
  }

  if (!template) {
    return <ErrorPage error={new Error("Process template not found")} />;
  }

  if (isError) {
    return <ErrorPage error={error} />;
  }

  return (
    <>
      <Section.Title
        breadcrumb={
          <>
            <Breadcrumb href={{ to: "/admin/processes" }}>Processes</Breadcrumb>
            <Breadcrumb>{template.name}</Breadcrumb>
          </>
        }
        actions={<Button variant="destructive">Delete</Button>}
      >
        {template.name}
      </Section.Title>
      <ProcessTemplateDetails template={template} />
    </>
  );
}
